import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/features/auth'
import { SupervisaoVendasService, SupervisaoEquipeData } from '../services/supervisaoVendas.service'

interface UseSupervisaoVendasOptions {
  mes?: number
  ano?: number
  supervisorId?: string
  enabled?: boolean
}

export function useSupervisaoVendas(options: UseSupervisaoVendasOptions = {}) {
  const { state: { user } } = useAuth()
  const now = new Date()

  const mes = options.mes ?? now.getMonth() + 1
  const ano = options.ano ?? now.getFullYear()
  const supervisorId = options.supervisorId ?? user?.uuid ?? (user?.id ? String(user.id) : undefined)
  const enabled = options.enabled !== false && !!supervisorId

  const query = useQuery<SupervisaoEquipeData>({
    queryKey: ['supervisao-vendas', supervisorId, mes, ano],
    queryFn: () => SupervisaoVendasService.getEquipeVendas(supervisorId!, Number(mes), Number(ano)),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutos
  })

  return {
    ...query,
    periodo: { mes, ano },
  }
}
